import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
// import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import AddTeacherModal from "../formmodals/addteachermodal/AddTeacherModal";
import TrainingDetailsModal from "./TrainingDetailsModal.jsx";

const TeachersTable = ({ data, schoolName, schoolID, setReload }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [teacher, setTeacher] = useState(null); // Teacher to update
  const isIndividualSchool = user.view_access_list.isIndividualSchool;
  const [courses, setCourses] = useState([]);
  const [trainingDialogOpen, setTrainingDialogOpen] = useState(false);

  // interface RootObject {
  //   crs_id: string;
  //   crs_title: string;
  //   crs_image: string;
  //   cat_name: string;
  //   video_usage: string;
  //   excs_usage: string;
  // }

  var columns = [
    {
      field: "sl_no",
      headerName: "Sl No.",
      flex: 1,
      maxWidth: 80,
    },
    {
      field: "Teacher_Name",
      headerName: "Teacher Name",
      flex: 1,
      maxWidth: 350,
    },
    {
      field: "video_usage",
      headerName: "Video Usage (min)",
      flex: 1,
      maxWidth: 180,
      renderCell: (params) => (
        <div className="flex justify-center">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            compactDisplay: "short",
          }).format(params.row.video_usage)}
        </div>
      ),
    },
    {
      field: "excs_usage",
      headerName: "Exercise Usage (min)",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => (
        <div className="flex justify-center">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            compactDisplay: "short",
          }).format(params.row.excs_usage)}
        </div>
      ),
    },
    {
      field: "training_done",
      headerName: "Usage Details",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => (
        <Button
          variant="contained"
          onClick={() => {
            setTeacher(params.row);
            setTrainingDialogOpen(true);
          }}
        >
          View
        </Button>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <div className="flex justify-center w-full">
          <IconButton
            color="primary"
            sx={{
              "&:focus": {
                outline: "none",
              },
            }}
            onClick={() => {
              setTeacher(params.row);
              setOpen(true);
            }}
          >
            <EditOutlinedIcon />
          </IconButton>
          <IconButton
            color="error"
            sx={{
              "&:focus": {
                outline: "none",
              },
            }}
          >
            <DeleteOutlineOutlinedIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  if (isIndividualSchool) {
    columns = columns.filter((column) => column.field !== "actions");
  }

  const handleOpenModal = () => {
    setOpen(true);
  };

  const getCourses = useCallback(async () => {
    try {
      const res = await axiosInstance.post("/getCourses", {
        auth_token: user.auth_token,
        user_id: user.user_id,
      });
      setCourses(res.data.data.courses);
    } catch (err) {
      alert(err.message);
    }
  }, [user.auth_token, user.user_id]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter />
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </GridToolbarContainer>
    );
  }

  useEffect(() => {
    getCourses();
  }, [getCourses]);

  if (data) {
    data = data.map((teacher, index) => {
      return {
        ...teacher,
        sl_no: index + 1,
        video_usage: parseInt(teacher.video_usage),
        excs_usage: parseInt(teacher.excs_usage),
        training_done: parseInt(teacher.training_done),
      };
    });
  }
  return (
    <TableContainer
      component={Paper}
      className="tableContainer"
      sx={{ boxShadow: "2px 4px 10px 1px rgba(201, 201, 201, 0.47)" }}
    >
      <div className="flex justify-between items-center">
        <span className="font-bold ml-2">Teachers</span>
        {user.user_type === "admin" && (
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddOutlinedIcon />}
            onClick={handleOpenModal}
          >
            Add New Teacher
          </Button>
        )}
      </div>
      <div>
        {data && (
          <DataGrid
            columns={columns}
            rows={data}
            getRowId={(row) => row.sl_no}
            autoHeight={true}
            pagination
            pageSize={5}
            rowsPerPageOptions={[5]}
            sx={{ border: "none" }}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        )}
      </div>
      <AddTeacherModal
        setReload={setReload}
        schoolName={schoolName}
        schoolID={schoolID}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        teacher={teacher}
        courses={courses}
      />
      <TrainingDetailsModal
        setReload={setReload}
        schoolName={schoolName}
        schoolID={schoolID}
        open={trainingDialogOpen}
        onClose={() => {
          setTeacher(null);
          setTrainingDialogOpen(false);
        }}
        teacher={teacher}
      />
    </TableContainer>
  );
};

export default TeachersTable;
